/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_University_PlaceholderInputs */

const en_onboarding_university_placeholder = /** @type {(inputs: Onboarding_University_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter university`)
};

const es_onboarding_university_placeholder = /** @type {(inputs: Onboarding_University_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu universidad`)
};

/**
* | output |
* | --- |
* | "Enter university" |
*
* @param {Onboarding_University_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_university_placeholder = /** @type {((inputs?: Onboarding_University_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_University_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_university_placeholder(inputs)
	return en_onboarding_university_placeholder(inputs)
});